<template>
    <div>
        <ag-grid-vue
            :rowData="data"
            ref="agGridTable"
            :gridOptions="gridOptions"
            :animateRows="true"
            @grid-ready="onGridReady"
            rowSelection="single"
            class="ag-theme-alpine ag-theme-material w-100 my-4 ag-grid-table"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            colResizeDefault="shift"
            :sideBar="'columns'"
        >
        </ag-grid-vue>
        <a-pagination
            @change="change_page"
            v-model="current"
            :page-size="20"
            :total="total">

        </a-pagination>

    </div>

</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
export default {
    name: "Page",
    components:{
        AgGridVue
    },
    data(){
        return{
            current: 1,
            save_data:[],
            data:[],
            total:0,
            gridApi: null,
        }
    },
    props:{
        columnDefs:{
            type:Array,
            default: () => []
        },
        gridOptions:{
            type:Object,
            default: () => {}
        },
        defaultColDef:{
            type:Object,
            default: () => {}
        },
        function_to_get_list:{
            type: Function,
        },

    },
    watch:{
        // async current(val) {
        //     await this.change_router(val)
        //     await this.get_data()
        // },
    },
    async mounted() {

    },
    methods:{
        onGridReady(params) {
            this.gridApi = params.api;
        },
        async change_page(page){
            this.current = page
            await this.change_router(page)
            await this.get_data()
        },
        async change_router(page){
            let queries = {
                ...this.$route.query,
                page:page,
            };
            await this.$router.replace({ name: this.$route.name, query: queries });
        },
        async methods_mounted(){
            if (!this.$route.query.page){
                await this.change_router(this.current)
            }else{
                this.current = Number(this.$route.query.page)
            }
            await this.get_data()
        },
        async get_data(updated=false){
            this.$vs.loading()
            let page = this.$route.query.page
            let save_data_find = this.save_data.find(item=>item.page==page)
            if (save_data_find){
                this.data = await save_data_find.data
            }else{
                let res = await this.updated_data()
                this.save_data.push({
                    page:String(page),
                    data:res.results,
                })
            }
            this.$vs.loading.close()
        },
        async updated_data(){
            let r_data
            await this.function_to_get_list(this.$route.query)
                .then(async (res)=>{
                    this.data = await res.results
                    this.total = await res.count
                    r_data = await res
                })

            return r_data
        }
    }
};
</script>

<style>
.ag-root-wrapper {
    border-radius: 5px;
    border: 1px solid #e8e8e8 !important;
    background: #fff;

}
</style>
